import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class TokenCampaignUsers extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  static modelName = 'TokenCampaignUsers'
  static instanceDefaults() {
    return {};
  }
}
const servicePath = '/token-campaign-users';
const servicePlugin = makeServicePlugin({
  Model: TokenCampaignUsers,
  service: feathersClient.service(servicePath),
  servicePath
});

feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
